export default {
        "logout-success": "Logout successful",
        "logout-error": "Failed to log out",
        "confirm": "Confirm",
        "copySuccess": "Copied",
        "server": {
            "selectServer": "Select Server",
            "serverAmerica": "America",
            "serverEurope": "Europe",
            "serverAsia": "Asia",
            "serverHMT": "HMT",
            "serverSEA": "SEA",
            "noRole": "Character profile empty.\nPlease enter the game first.",
            "noRole2": "Character profile empty.",
            "noOtherRole": "Characters not found, \nunable to switch servers."
        },
        "uidlogin": { 
            "enterCode": "Please enter the code",
            "enterCode2": "Please enter the correct code",
            "sendCode": "Send code",
            "agree": "Please read and agree to the Terms of Use and Privacy Policy",
            "sended": "Sent",
            "tipUid": "Please enter the UID",
            "tipUid2": "Please enter the correct UID",
            "login": "Login",
            "loginFail": "Login failed, please check the UID and code",
            "loginSuccess": "Login successful",
            "sendFail": "No role found",
            "sendFail2": "Send failed",
            "sendFast": "Send too fast",
            "sendFast2": "Send too fast, please try again in {time}",
            "codeInvaild": "Code expired"
        },
        "share-tips": "Press and hold to save and share the image"
};
